'use strict';

exports.__esModule = true;

var _maxBy2 = require('lodash/maxBy');

var _maxBy3 = _interopRequireDefault(_maxBy2);

var _minBy2 = require('lodash/minBy');

var _minBy3 = _interopRequireDefault(_minBy2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _defaultProps = require('recompose/defaultProps');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _d3Scale = require('d3-scale');

var _hocs = require('../../../hocs');

var _props = require('./props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
exports.default = function (Component) {
    return (0, _compose2.default)((0, _defaultProps2.default)(_props.CalendarDefaultProps), (0, _hocs.withTheme)(), (0, _hocs.withDimensions)(), (0, _withPropsOnChange2.default)(['data', 'domain', 'colors'], function (_ref) {
        var data = _ref.data,
            domain = _ref.domain,
            colors = _ref.colors;

        var colorDomain = void 0;
        if (domain === 'auto') {
            colorDomain = [(0, _minBy3.default)(data, 'value').value, (0, _maxBy3.default)(data, 'value').value];
        } else {
            colorDomain = [].concat(domain);
        }

        var colorScale = (0, _d3Scale.scaleQuantize)().domain(colorDomain).range(colors);

        return { colorScale: colorScale };
    }), _pure2.default)(Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/nivo/lib/components/charts/calendar/enhance.js
// module id = 1090
// module chunks = 0